const SETTINGS = {
    backgroundAudio: `/assets/studioBuds/audio/10_Music Loop/MUSIC LOOP_Option 3.mp3`, 
    backgroundWelcomeBackScreen: { prop: 'backgroundImage', value: { path: `/assets/images/bg_red.jpg` } }
  }
  
export default SETTINGS